export default __webpack_public_path__ + "bfe048eac966d8941b8b3776a296e2a4.svg";